import { translate } from '@/domains/core/localization/translate';
export const {
  economicOperatorDisclaimerTitle
} = translate({
  "economicOperatorDisclaimerTitle": "Manufacturer & responsible person contacts"
});
export const {
  economicOperatorDisclaimerLegalIntro
} = translate({
  "economicOperatorDisclaimerLegalIntro": ""
});
export const {
  economicOperatorManufacturerSubtitle
} = translate({
  "economicOperatorManufacturerSubtitle": "Manufacturer information"
});
export const {
  economicOperatorSubtitle
} = translate({
  "economicOperatorSubtitle": "EU responsible person"
});
export const {
  economicOperatorMissingManufacturerData
} = translate({
  "economicOperatorMissingManufacturerData": "The manufacturer information is currently not available."
});
export const {
  economicOperatorMissingOperatorData
} = translate({
  "economicOperatorMissingOperatorData": "The seller's EU responsible person information is currently not available."
});